import {Signal} from "@angular/core";

export abstract class BackNavigationService {
  // Whether the most recent navigation was a back navigation (navigateBack() or a
  // browser/Location.back() popstate). Authoritative source for direction-aware
  // behaviour such as transition animations and scroll-position restoration.
  abstract readonly lastNavigationWasBack: Signal<boolean>;
  abstract initialize(): void;
  abstract navigateBack(): void;
}

/**
 * Navigation state that takes the page being left out of Back's history (the header arrow, Android
 * Back, the iOS swipe) as replaceUrl would, but keeps its entry in the browser's own history.
 */
const leaveOutKey = 'leaveOutOfBackHistory';
export const leaveOutOfBackHistory = {[leaveOutKey]: true} as const;

export function isLeftOutOfBackHistory(state: Record<string, unknown> | undefined): boolean {
  return state?.[leaveOutKey] === true;
}
